import "@mui/lab/themeAugmentation";

import { type Components, type Theme } from "@mui/material/styles";

export const timelineDot: Components<Theme>["MuiTimelineDot"] = {
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      const isFilled = ownerState.variant === "filled";
      const isOutlined = ownerState.variant === "outlined";

      return {
        ...(isFilled && {
          backgroundColor: theme.palette.gray[400],
          borderColor: theme.palette.gray[400],
        }),
        ...(isOutlined && {
          borderColor: theme.palette.gray[400],
        }),
      };
    },
  },
};
